<template>
  <div class="row justify-center items-center full-width">
    <q-tabs
      v-model="tab"
      active-color="primary"
      indicator-color="transparent"
      align="justify"
      dense
      narrow-indicator
      class="text-grey-8 q-pa-sm"
    >
      <q-route-tab
        v-for="item in tabItems"
        :key="item.name"
        :name="item.name"
        no-caps
        :to="{ name: item.to || item.name }"
        class="full-width"
      >
        <q-icon :name="item.icon" size="sm">
          <q-badge
            v-if="item.name === NAIL_SUPPLY_ROUTE_NAME.CART"
            color="red"
            floating
            rounded
            :label="cartItemCount > 99 ? '99+' : cartItemCount"
            style="top: -10%"
          />
        </q-icon>
        <div class="q-mt-xs wrap-text full-width" style="font-size: 8px">
          {{ item.label }}
        </div>
      </q-route-tab>
      <!-- <q-tab v-for="item in tabItems" :key="item.name" :name="item.name"
      @click="() => router.push({ name: item.to || item.name })" no-caps>
      <q-icon :name="item.icon" size="sm" />
      <div class="text-center q-mt-xs wrap-text" style="font-size: 8px">
        {{ item.label }}
      </div>
    </q-tab> -->
    </q-tabs>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import { ref, computed, watch, onMounted } from "vue";
import type { TabItem } from "@/types/common";
import { useCartStore } from "@/stores/cartStore";
import {
  NAIL_SUPPLY_ROUTE_NAME,
  PROMOTION_ROUTE_NAME,
  JOB_ROUTE_NAME,
  WORKER_ROUTE_NAME,
  SALON_ROUTE_NAME,
  ACCOUNT_ROUTE_NAME
} from "@/libs/route-name";
import {
  mdiHome,
  mdiForumOutline,
  mdiCart,
  mdiWalletTravel,
  mdiAccountCircle
} from "@quasar/extras/mdi-v7";

const route = useRoute();
const cartStore = useCartStore();

const cartItemCount = computed(() => {
  return cartStore.getCurrentCart?.cart?.total_quantity || 0;
});
const tabItems = ref<TabItem[]>([
  {
    name: NAIL_SUPPLY_ROUTE_NAME.CATEGORY,
    to: NAIL_SUPPLY_ROUTE_NAME.CATEGORY,
    icon: mdiHome,
    label: "Nail Supply",
    aliases: [NAIL_SUPPLY_ROUTE_NAME.CATEGORY, NAIL_SUPPLY_ROUTE_NAME.PRODUCT]
  },
  {
    name: PROMOTION_ROUTE_NAME.PROMOTION,
    to: PROMOTION_ROUTE_NAME.PROMOTION,
    icon: mdiForumOutline,
    label: "Forum",
    aliases: [PROMOTION_ROUTE_NAME.PROMOTION]
  },
  {
    name: NAIL_SUPPLY_ROUTE_NAME.CART,
    to: NAIL_SUPPLY_ROUTE_NAME.CART,
    icon: mdiCart,
    label: "Cart",
    aliases: [
      NAIL_SUPPLY_ROUTE_NAME.CART,
      NAIL_SUPPLY_ROUTE_NAME.SHIPPING_INFORMATION,
      NAIL_SUPPLY_ROUTE_NAME.CHECKOUT
    ]
  },
  {
    name: "technician",
    to: JOB_ROUTE_NAME.HOME,
    icon: mdiWalletTravel,
    label: "Nail Jobs",
    aliases: [
      JOB_ROUTE_NAME.HOME,
      WORKER_ROUTE_NAME.HOME,
      SALON_ROUTE_NAME.HOME,
      JOB_ROUTE_NAME.DETAIL,
      WORKER_ROUTE_NAME.DETAIL,
      SALON_ROUTE_NAME.DETAIL,
      "technician"
    ]
  },
  {
    name: ACCOUNT_ROUTE_NAME.ACCOUNT,
    to: ACCOUNT_ROUTE_NAME.ACCOUNT,
    icon: mdiAccountCircle,
    label: "Account",
    aliases: [ACCOUNT_ROUTE_NAME.ACCOUNT]
  }
]);

const tab = ref("");

const activeTab = computed(() => {
  const routeName = route.name?.toString() ?? "";
  const matched = tabItems.value.find(item =>
    item.aliases?.includes(routeName)
  );
  return matched ? matched.name : "";
});

watch(
  () => route.name,
  newRouteName => {
    const routeName = newRouteName?.toString() ?? "";
    const matched = tabItems.value.find(item =>
      item.aliases?.includes(routeName)
    );
    tab.value = matched ? matched.name : "";
  },
  { immediate: true }
);

onMounted(() => {
  tab.value = activeTab.value;
});
</script>

<style scoped>
.wrap-text {
  white-space: normal;
  word-break: break-word;
  text-align: center;
  min-height: 28px;
}
:deep(.q-tab__content) {
  min-width: 41px !important;
}
</style>
